import React from "react";
import fileIcon from "../../assets/file.png";
import arrowDownIcon from "../../assets/arrow-down.svg";

const GuidenTab = ({ collapse, handleCollapse, listGuide }) => {
  return (
    <div
      className="tab-pane fade show active"
      id="pills-riwayat"
      role="tabpanel"
      aria-labelledby="pills-riwayat-tab"
    >
      {listGuide.length
        ? listGuide.map((guide) => {
            return (
              <>
                <div className="collapse-regulasi" id={guide._id}>
                  <table className="table-borderless w-100">
                    <tr>
                      <td>
                        <div className="circle-blue mr-4">
                          <img
                            className="mx-auto d-block"
                            src={fileIcon}
                            alt="file"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      </td>
                      <td style={{ width: "87%" }}>
                        <p className="mb-0" style={{ fontSize: "15px" }}>
                          {guide.name}
                        </p>
                      </td>
                      <td>
                        {/* <a
                          target="_blank"
                          href={guide.regulationFile}
                          className="btn btn-green d-lg-block d-md-block d-sm-none d-none"
                          style={{
                            borderRadius: "20px",
                            color: "white",
                            width: " fit-content",
                          }}
                        >
                          Download
                        </a> */}
                      </td>
                      <td>
                        <div
                          data-toggle="collapse"
                          role="button"
                          aria-expanded="false"
                          onClick={() => handleCollapse(guide._id)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={arrowDownIcon}
                            alt="down-arrow"
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  className={
                    collapse === guide._id ? "collapse show" : "collapse"
                  }
                  id={guide._id}
                >
                  <div className="collapseContent">
                    {guide.description}
                    {/* <a
                      href=""
                      className="btn btn-green d-lg-none d-md-none d-sm-block d-block mt-5"
                      style={{
                        borderRadius: "20px",
                        color: "white",
                        width: "fit-content",
                      }}
                    >
                      Download
                    </a> */}
                  </div>
                </div>
              </>
            );
          })
        : "No data founded"}
    </div>
  );
};

export default GuidenTab;
